<template>
  <div class="mx-4">
    <addProductDialog :units="units"/>
    <v-divider></v-divider>
    <v-data-table :headers="headers" :items="supplierProducts" :page.sync="page" @page-count="pageCount = $event" hide-default-footer :items-per-page="10" class="elevation-0">
      <template v-slot:[`item.number`]="{item}">
            {{supplierProducts.indexOf(item)+1}}
      </template>
      <template v-slot:[`item.image`]="{ item }">
        <v-avatar size="60px" tile class="ma-1">
          <img :src="item.imageUrl" alt>
        </v-avatar>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-row>
          <updateProductDialog :product="item" :key="item.id" :units="units" />
          <deleteProductDialog :product="item" :key="item.createdOn" />
        </v-row>
      </template>
    </v-data-table>
    <v-divider></v-divider>
    <div class="text-center pt-2">
      <v-pagination v-model="page" :length="pageCount"></v-pagination>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import addProductDialog from '@/components/admin/product/AddProductDialog'
import updateProductDialog from '@/components/admin/product/updateProductDialog'
import deleteProductDialog from '@/components/admin/product/deleteProductDialog'

export default {
  name: 'MyProducts',
  components: { addProductDialog, updateProductDialog, deleteProductDialog },
  data() {
    return {
      page: 1,
      pageCount: 0,
      headers: [
        {
          text: 'N°',
          align: 'start',
          value: 'number'
        },
        {
          text: 'Image',
          value: 'image'
        },
        { text: 'Title', value: 'title' },
        { text: 'Category', value: 'category' },
        { text: 'Price(ZK)', value: 'price' },
        { text: 'Unit', value: 'unit' },
        { text: 'Location', value: 'district' },
        { text: 'Actions', value: 'actions', sortable: false }
      ]
    }
  },
  computed: {
    ...mapGetters(['user', 'supplierProducts', 'units'])
  },
  methods: {}
}
</script>

<style scoped>
.v-icon.mdi-delete:hover {
  color: red;
}
</style>
